import React, { Component } from "react";
import Button from "../components/Button";
import {
  randomArrayElement,
  arrayShuffle,
  shuffleAnswer,
  randomArrayElementImplement,
} from "../utils/random";
import GameSetting from "../config/gameWisconsinCardSorting";
import image_circle1red from "../static/images/wisconsin_card/circle1red.png";
import image_circle1green from "../static/images/wisconsin_card/circle1green.png";
import image_circle1blue from "../static/images/wisconsin_card/circle1blue.png";
import image_circle1yellow from "../static/images/wisconsin_card/circle1yellow.png";
import image_circle2red from "../static/images/wisconsin_card/circle2red.png";
import image_circle2green from "../static/images/wisconsin_card/circle2green.png";
import image_circle2blue from "../static/images/wisconsin_card/circle2blue.png";
import image_circle2yellow from "../static/images/wisconsin_card/circle2yellow.png";
import image_circle3red from "../static/images/wisconsin_card/circle3red.png";
import image_circle3green from "../static/images/wisconsin_card/circle3green.png";
import image_circle3blue from "../static/images/wisconsin_card/circle3blue.png";
import image_circle3yellow from "../static/images/wisconsin_card/circle3yellow.png";
import image_circle4red from "../static/images/wisconsin_card/circle4red.png";
import image_circle4green from "../static/images/wisconsin_card/circle4green.png";
import image_circle4blue from "../static/images/wisconsin_card/circle4blue.png";
import image_circle4yellow from "../static/images/wisconsin_card/circle4yellow.png";
import image_cross1red from "../static/images/wisconsin_card/cross1red.png";
import image_cross1green from "../static/images/wisconsin_card/cross1green.png";
import image_cross1blue from "../static/images/wisconsin_card/cross1blue.png";
import image_cross1yellow from "../static/images/wisconsin_card/cross1yellow.png";
import image_cross2red from "../static/images/wisconsin_card/cross2red.png";
import image_cross2green from "../static/images/wisconsin_card/cross2green.png";
import image_cross2blue from "../static/images/wisconsin_card/cross2blue.png";
import image_cross2yellow from "../static/images/wisconsin_card/cross2yellow.png";
import image_cross3red from "../static/images/wisconsin_card/cross3red.png";
import image_cross3green from "../static/images/wisconsin_card/cross3green.png";
import image_cross3blue from "../static/images/wisconsin_card/cross3blue.png";
import image_cross3yellow from "../static/images/wisconsin_card/cross3yellow.png";
import image_cross4red from "../static/images/wisconsin_card/cross4red.png";
import image_cross4green from "../static/images/wisconsin_card/cross4green.png";
import image_cross4blue from "../static/images/wisconsin_card/cross4blue.png";
import image_cross4yellow from "../static/images/wisconsin_card/cross4yellow.png";
import image_star1red from "../static/images/wisconsin_card/star1red.png";
import image_star1green from "../static/images/wisconsin_card/star1green.png";
import image_star1blue from "../static/images/wisconsin_card/star1blue.png";
import image_star1yellow from "../static/images/wisconsin_card/star1yellow.png";
import image_star2red from "../static/images/wisconsin_card/star2red.png";
import image_star2green from "../static/images/wisconsin_card/star2green.png";
import image_star2blue from "../static/images/wisconsin_card/star2blue.png";
import image_star2yellow from "../static/images/wisconsin_card/star2yellow.png";
import image_star3red from "../static/images/wisconsin_card/star3red.png";
import image_star3green from "../static/images/wisconsin_card/star3green.png";
import image_star3blue from "../static/images/wisconsin_card/star3blue.png";
import image_star3yellow from "../static/images/wisconsin_card/star3yellow.png";
import image_star4red from "../static/images/wisconsin_card/star4red.png";
import image_star4green from "../static/images/wisconsin_card/star4green.png";
import image_star4blue from "../static/images/wisconsin_card/star4blue.png";
import image_star4yellow from "../static/images/wisconsin_card/star4yellow.png";
import image_triangle1red from "../static/images/wisconsin_card/triangle1red.png";
import image_triangle1green from "../static/images/wisconsin_card/triangle1green.png";
import image_triangle1blue from "../static/images/wisconsin_card/triangle1blue.png";
import image_triangle1yellow from "../static/images/wisconsin_card/triangle1yellow.png";
import image_triangle2red from "../static/images/wisconsin_card/triangle2red.png";
import image_triangle2green from "../static/images/wisconsin_card/triangle2green.png";
import image_triangle2blue from "../static/images/wisconsin_card/triangle2blue.png";
import image_triangle2yellow from "../static/images/wisconsin_card/triangle2yellow.png";
import image_triangle3red from "../static/images/wisconsin_card/triangle3red.png";
import image_triangle3green from "../static/images/wisconsin_card/triangle3green.png";
import image_triangle3blue from "../static/images/wisconsin_card/triangle3blue.png";
import image_triangle3yellow from "../static/images/wisconsin_card/triangle3yellow.png";
import image_triangle4red from "../static/images/wisconsin_card/triangle4red.png";
import image_triangle4green from "../static/images/wisconsin_card/triangle4green.png";
import image_triangle4blue from "../static/images/wisconsin_card/triangle4blue.png";
import image_triangle4yellow from "../static/images/wisconsin_card/triangle4yellow.png";
import Howtoplay from "../components/Howtoplay";
import Waiting from "../components/Waiting";
import Passpracetice from "../components/Passpracetice";
import Game from "../containers/Game";
import styles from "./gamewisconsincardsorting.module.css";
import ButtonNextLevel from "../components/ButtonNextLevel";
import { GameData } from "../containers/GameContainer";
import IntroGame from "../components/IntroGame";
import StatusGame from "../components/StatusGame";
import { useData } from "../contexts/DataContext";
import CountdownTimer from "../components/CountdownTimer";
import LevelResult from "../components/LevelResult";

const Criteria = ["symbol", "color", "number"];
const CriteriaText = {
  symbol: "รูปทรง",
  color: "สี",
  number: "จำนวน",
};

const QuestionPool = [
  { symbol: "circle", number: 1, color: "red", image: image_circle1red },
  { symbol: "circle", number: 1, color: "green", image: image_circle1green },
  { symbol: "circle", number: 1, color: "blue", image: image_circle1blue },
  { symbol: "circle", number: 1, color: "yellow", image: image_circle1yellow },
  { symbol: "circle", number: 2, color: "red", image: image_circle2red },
  { symbol: "circle", number: 2, color: "green", image: image_circle2green },
  { symbol: "circle", number: 2, color: "blue", image: image_circle2blue },
  { symbol: "circle", number: 2, color: "yellow", image: image_circle2yellow },
  { symbol: "circle", number: 3, color: "red", image: image_circle3red },
  { symbol: "circle", number: 3, color: "green", image: image_circle3green },
  { symbol: "circle", number: 3, color: "blue", image: image_circle3blue },
  { symbol: "circle", number: 3, color: "yellow", image: image_circle3yellow },
  { symbol: "circle", number: 4, color: "red", image: image_circle4red },
  { symbol: "circle", number: 4, color: "green", image: image_circle4green },
  { symbol: "circle", number: 4, color: "blue", image: image_circle4blue },
  { symbol: "circle", number: 4, color: "yellow", image: image_circle4yellow },
  { symbol: "cross", number: 1, color: "red", image: image_cross1red },
  { symbol: "cross", number: 1, color: "green", image: image_cross1green },
  { symbol: "cross", number: 1, color: "blue", image: image_cross1blue },
  { symbol: "cross", number: 1, color: "yellow", image: image_cross1yellow },
  { symbol: "cross", number: 2, color: "red", image: image_cross2red },
  { symbol: "cross", number: 2, color: "green", image: image_cross2green },
  { symbol: "cross", number: 2, color: "blue", image: image_cross2blue },
  { symbol: "cross", number: 2, color: "yellow", image: image_cross2yellow },
  { symbol: "cross", number: 3, color: "red", image: image_cross3red },
  { symbol: "cross", number: 3, color: "green", image: image_cross3green },
  { symbol: "cross", number: 3, color: "blue", image: image_cross3blue },
  { symbol: "cross", number: 3, color: "yellow", image: image_cross3yellow },
  { symbol: "cross", number: 4, color: "red", image: image_cross4red },
  { symbol: "cross", number: 4, color: "green", image: image_cross4green },
  { symbol: "cross", number: 4, color: "blue", image: image_cross4blue },
  { symbol: "cross", number: 4, color: "yellow", image: image_cross4yellow },
  { symbol: "star", number: 1, color: "red", image: image_star1red },
  { symbol: "star", number: 1, color: "green", image: image_star1green },
  { symbol: "star", number: 1, color: "blue", image: image_star1blue },
  { symbol: "star", number: 1, color: "yellow", image: image_star1yellow },
  { symbol: "star", number: 2, color: "red", image: image_star2red },
  { symbol: "star", number: 2, color: "green", image: image_star2green },
  { symbol: "star", number: 2, color: "blue", image: image_star2blue },
  { symbol: "star", number: 2, color: "yellow", image: image_star2yellow },
  { symbol: "star", number: 3, color: "red", image: image_star3red },
  { symbol: "star", number: 3, color: "green", image: image_star3green },
  { symbol: "star", number: 3, color: "blue", image: image_star3blue },
  { symbol: "star", number: 3, color: "yellow", image: image_star3yellow },
  { symbol: "star", number: 4, color: "red", image: image_star4red },
  { symbol: "star", number: 4, color: "green", image: image_star4green },
  { symbol: "star", number: 4, color: "blue", image: image_star4blue },
  { symbol: "star", number: 4, color: "yellow", image: image_star4yellow },
  { symbol: "triangle", number: 1, color: "red", image: image_triangle1red },
  {
    symbol: "triangle",
    number: 1,
    color: "green",
    image: image_triangle1green,
  },
  { symbol: "triangle", number: 1, color: "blue", image: image_triangle1blue },
  {
    symbol: "triangle",
    number: 1,
    color: "yellow",
    image: image_triangle1yellow,
  },
  { symbol: "triangle", number: 2, color: "red", image: image_triangle2red },
  {
    symbol: "triangle",
    number: 2,
    color: "green",
    image: image_triangle2green,
  },
  { symbol: "triangle", number: 2, color: "blue", image: image_triangle2blue },
  {
    symbol: "triangle",
    number: 2,
    color: "yellow",
    image: image_triangle2yellow,
  },
  { symbol: "triangle", number: 3, color: "red", image: image_triangle3red },
  {
    symbol: "triangle",
    number: 3,
    color: "green",
    image: image_triangle3green,
  },
  { symbol: "triangle", number: 3, color: "blue", image: image_triangle3blue },
  {
    symbol: "triangle",
    number: 3,
    color: "yellow",
    image: image_triangle3yellow,
  },
  { symbol: "triangle", number: 4, color: "red", image: image_triangle4red },
  {
    symbol: "triangle",
    number: 4,
    color: "green",
    image: image_triangle4green,
  },
  { symbol: "triangle", number: 4, color: "blue", image: image_triangle4blue },
  {
    symbol: "triangle",
    number: 4,
    color: "yellow",
    image: image_triangle4yellow,
  },
];
const answers = [
  {
    symbol: "circle",
    number: 1,
    color: "red",
    imgSrc: image_circle1red,
  },
  {
    symbol: "triangle",
    number: 2,
    color: "green",
    imgSrc: image_triangle2green,
  },
  {
    symbol: "cross",
    number: 3,
    color: "blue",
    imgSrc: image_cross3blue,
  },
  {
    symbol: "star",
    number: 4,
    color: "yellow",
    imgSrc: image_star4yellow,
  },
];

class GameWisconsinCardSorting extends Component {
  constructor() {
    super();

    // game loop
    this.animationID = null;
    this.lastUpdate = null;
    this.questionShowAt = null;

    // game state
    this.state = {
      id: "5",
      showHowtoplay: false,
      showIntro: true,
      showLevel: false,
      passLevel: false,
      action: "cooldown",
      level: 0,
      round: 0,
      result: Array(GameSetting.level.length).fill([]),
      question: null,
      practice: true,
      currentcriteria: "",
      practicelevel: 1,
      answers: [answers],
    };
    this.practiceCriteria = [
      "color", // practice
      ...arrayShuffle(Criteria),
    ];
  }

  restartGame() {
    this.setState({
      showIntro: false,
      showHowtoplay: true,
      level: 0,
      round: 0,
      practice: true,
      practicelevel: 1,
      result: Array(GameSetting.level.length).fill([]),
    });
  }

  startGame() {
    this.setState({
      showHowtoplay: false,
      showLevel: false,
    });
    this.lastUpdate = null;
    this.animationID = requestAnimationFrame((now) => this.gameLoop(now));
  }

  showHowtoPlay() {
    this.setState({
      showIntro: false,
      showHowtoplay: true,
    });
  }

  gameLoop(now) {
    if (!this.lastUpdate) {
      this.lastUpdate = now;
    }

    const delta = now - this.lastUpdate;
    const levelSetting = GameSetting.level[this.state.level];

    switch (this.state.action) {
      case "cooldown":
        if (delta > levelSetting.cooldownTime) {
          if (this.state.round === levelSetting.round) {
            // next level
            this.nextLevel();
          } else {
            // next round
            const q = randomArrayElement(QuestionPool);
            const newCriteria = randomArrayElementImplement(Criteria);
            const newAnswers = shuffleAnswer(answers);
            this.setState((state) => ({
              round: state.round + 1,
              question: q,
              action: "play",
              currentcriteria: newCriteria,
              answers: newAnswers,
            }));
          }
          this.lastUpdate = now;
        }
        break;

      case "play":
        if (delta > levelSetting.displayTime) {
          this.nextRound("timeout");
          this.lastUpdate = now;
        }
        break;

      default:
    }

    if (this.animationID) {
      this.animationID = requestAnimationFrame((now) => this.gameLoop(now));
    }
  }

  nextRound(roundResult, responseTime = 0) {
    if (this.state.practice) {
      this.setState((state) => ({
        practicelevel: state.practicelevel + 1,
      }));
    }
    this.setState((state) => ({
      question: null,
      currentcriteria: null,
      action: "cooldown",
      result: Object.assign([], state.result, {
        [this.state.level]: [
          ...state.result[this.state.level],
          {
            result: roundResult,
            responseTime,
          },
        ],
      }),
    }));
  }

  clickAnswer(ans) {
    // clear timer, so it doesn't wait for displayTime

    this.lastUpdate = null;
    if (this.state.practice) {
      const currentCriteria =
        this.practiceCriteria[this.state.level + this.state.practicelevel];
      const now = new Date();
      this.nextRound(
        ans[currentCriteria] === this.state.question[currentCriteria]
          ? "correct"
          : "wrong",
        now - this.questionShowAt
      );
    } else {
      const now = new Date();
      this.nextRound(
        ans[this.state.currentcriteria] === this.state.question[this.state.currentcriteria]
          ? "correct"
          : "wrong",
        now - this.questionShowAt
      );
    }
  }

  nextLevel() {
    const levelSetting = GameSetting.level[this.state.level];
    const score_default = GameSetting.level[1].score;
    cancelAnimationFrame(this.animationID);
    this.animationID = null;
    this.lastUpdate = null;


    const levelScore =
      score_default *
      this.state.result[this.state.level].reduce(
        (sum, cur) => sum + (cur.result === "correct" ? 1 : 0),
        0
      );

    this.setState((state) => ({
      round: 0,
      level: state.level + 1,
      showLevel: true,
      passLevel: levelScore >= (levelSetting.passScore ?? 0),
    }));
    if (this.state.practice) {
      this.setState(() => ({
        practice: false,
      }));
    }
  }

  async nextGame() {
    this.props.submitResult(this.state.id, this.state.result);
    let data = {
      [this.state.id]: this.state.result
        .filter((result, index) => index !== 0 && result.length > 0) 
        .map(result => 
         result.map((answer,no) => ({
            no,
            result: answer.result,
            responseTime: answer.responseTime
          }))
        )
    };
    await this.props.updateAllResult(data);    
    this.props.navigateNextPage();
  }

  componentDidUpdate(_, prevState) {
    if (
      prevState.action !== this.state.action &&
      this.state.action === "play"
    ) {
      this.questionShowAt = new Date();
    }
  }

  render() {
    const levelSetting = GameSetting.level[this.state.level];
    const score_default = GameSetting.level[1].score;
    if (this.state.showIntro) {
      return (
        <IntroGame icon={GameData[4].gamePic} headname="เกมทดสอบที่ 5 :">
          <Button onClick={() => this.showHowtoPlay()}>ทำการทดสอบ</Button>
        </IntroGame>
      );
    }
    if (this.state.showHowtoplay) {
      return (
        <div>
          <Howtoplay id={this.state.id} />
          <Button onClick={() => this.startGame()}>ทดลองเล่น</Button>
        </div>
      );
    }
    if (this.state.showLevel) {
      const prevLevelSetting = GameSetting.level[this.state.level - 1];
      const levelScore =
        score_default *
        this.state.result[this.state.level - 1].reduce(
          (sum, cur) => sum + (cur.result === "correct" ? 1 : 0),
          0
        );
      const totalmilliTime = this.state.result[this.state.level - 1].reduce(
        (sum, item) => {
          const responseTime =
            item.responseTime === 0
              ? prevLevelSetting.displayTime
              : item.responseTime;
          return sum + responseTime;
        },
        0
      );
      const totalTime = (
        totalmilliTime /
        prevLevelSetting.round /
        1000
      ).toFixed(2);
      return (
        <div className={styles.passpracetice}>
          {prevLevelSetting.practice ? (
            <>
              {this.state.passLevel ? (
                <Passpracetice pass={this.state.passLevel}>
                  คุณผ่านการทดลองเล่นแล้ว ต่อไปคือการทดสอบจริง
                </Passpracetice>
              ) : (
                <>
                  <Passpracetice pass={this.state.passLevel}>
                    คุณยังไม่ผ่านการทดลองเล่น ต้องการทดลองเล่นเกมนี้อีกครั้งไหม
                  </Passpracetice>
                  <Button onClick={() => this.restartGame()}>
                    ทดลองเล่นอีกครั้ง
                  </Button>
                </>
              )}
            </>
          ) : (
            <>
              {this.state.passLevel ? (
                <>
                  <StatusGame status={"Pass"}>
                    คุณผ่านการทดสอบ <br />
                    {prevLevelSetting.name} แล้ว
                    <br />
                    ยินดีด้วย
                    <br />
                    มาทดสอบระดับต่อไปกัน
                  </StatusGame>
                  <LevelResult
                    name={"Wisconsincard Task"}
                    score={levelScore}
                    fullscore={prevLevelSetting.round}
                    time={totalTime}
                  />
                </>
              ) : (
                <>
                  <StatusGame status={"Fail"}>
                    คุณไม่ผ่านการทดสอบ {prevLevelSetting.name}
                  </StatusGame>
                  <LevelResult
                    name={"Wisconsincard Task"}
                    score={levelScore}
                    fullscore={prevLevelSetting.round}
                    time={totalTime}
                  />
                </>
              )}
            </>
          )}
          {(this.state.passLevel &&
            this.state.level < GameSetting.level.length) ||
          prevLevelSetting.practice ? (
            <ButtonNextLevel
              onClick={() => this.startGame()}
              Nextlevel={this.state.level}
            >
              {prevLevelSetting.practice
                ? this.state.passLevel
                  ? "เริ่มการทดสอบ"
                  : "ไม่ ฉันต้องการไปเริ่มทำการทดสอบ"
                : "ทดสอบ"}
            </ButtonNextLevel>
          ) : (
            <Button onClick={() => this.nextGame()}>
              กดเพื่อดูผลการทดสอบทั้งหมด
            </Button>
          )}
        </div>
      );
    }
    const practiceCriteria =
      this.practiceCriteria[this.state.level + this.state.practicelevel];

    return (
      <>
        {this.state.action === "play" ? (
          <div className={styles.body}>
            <div style={{ marginBottom: "50px" }}>
              <div className={styles.timer}>
                <CountdownTimer initialTime={levelSetting.displayTime} />
              </div>
              <Game
                name={levelSetting.name}
                round={this.state.round - 1}
                levelRound={levelSetting.round}
                id={this.state.id}
              >
                <div className={styles.bodyquestion}>
                  <div className={styles.flexcol}>
                    <div className={styles.question}>
                      <img src={this.state.question.image} alt="question" />
                    </div>
                    <div className={styles.questiontext}>
                      {this.state.practice ? (
                        <div className={styles.text}>
                          เลือกภาพที่เป็น "
                          <span className={styles.highlight}>
                            {CriteriaText[practiceCriteria]}
                          </span>
                          " เดียวกัน
                        </div>
                      ) : (
                        <div className={styles.text}>
                          เลือกภาพที่เป็น "
                          <span className={styles.highlight}>
                            {CriteriaText[this.state.currentcriteria]}
                          </span>
                          " เดียวกัน
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className={styles.flexrow}>
                  {this.state.answers.slice(0, 2).map((answer, index) => (
                    <div
                      key={index}
                      className={styles[`answer${index + 1}`]}
                      onClick={() =>
                        this.clickAnswer({
                          symbol: answer.symbol,
                          number: answer.number,
                          color: answer.color,
                        })
                      }
                    >
                      <img
                        src={answer.imgSrc}
                        className={styles.ansImg}
                        alt={`img-${answer.symbol}`}
                      />
                    </div>
                  ))}
                </div>
                <div className={styles.answerrow2}>
                  {answers.slice(2).map((answer, index) => (
                    <div
                      key={index + 2}
                      className={styles[`answer${index + 1}`]}
                      onClick={() =>
                        this.clickAnswer({
                          symbol: answer.symbol,
                          number: answer.number,
                          color: answer.color,
                        })
                      }
                    >
                      <img
                        src={answer.imgSrc}
                        className={styles.ansImg}
                        alt={`img-${answer.symbol}`}
                      />
                    </div>
                  ))}
                </div>
              </Game>
            </div>
          </div>
        ) : null}
        {this.state.action === "cooldown" && <Waiting />}
      </>
    );
  }
}

const WrapperGameWisconsinCardSorting = (props) => {
  const { id,updateAllResult } = useData();

  return <GameWisconsinCardSorting guid={id} updateAllResult={updateAllResult} {...props} />;
};

export default WrapperGameWisconsinCardSorting;
